module.exports = __webpack_public_path__ + "static/media/Modern_Backdrop.d89a02a3.png";